import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { siteFlags } from "@/config/siteFlags";

const allFaqs = [
  {    q: "Who is JobNex for?",
    a: "Right now, JobNex focuses exclusively on experienced engineers - mid and senior roles in AI, full-stack, and data (3-5L, 5-8L, 8L+ CTC). We work with best candidates who are serious about their next move and willing to invest in the right placement.",
  },
  {
    q: "How is this different from a recruiter or job board?",
    a: "Recruiters get paid by employers - their loyalty is there. Job boards send your resume into the void. JobNex is hired by you. We hand-pick your roles, write to the right HRs ourselves, and prep you for every round. You stay in control.",
  },
  {
    q: "What does the engagement actually cover?",
    a: "The full placement stack: structured screening, resume polish and positioning, direct HR outreach, interviews scheduled directly with the HR, and placement at the right role. Pricing is bespoke and based on your current CTC and target roles - we walk you through it openly on the consultation call.",
  },
  {
    id: "refund-placement",
    q: "What if I don't get placed?",
    a: "We'll keep working with you until you do. If we can't place you within the agreed window, you get the majority of your fee back - minus a small ongoing operational cost after month 3. Exact terms are shared during onboarding.",
  },
  {
    q: "Can I keep applying on my own in parallel?",
    a: "Yes. JobNex is not exclusive. We just want to make sure the best opportunities reach you - wherever they come from.",
  },  {
    q: "Do you work with companies outside India?",
    a: "Right now we focus on India-based and India-remote roles at top startups. International placements are case-by-case for senior candidates.",
  },
];

const faqs = allFaqs.filter(
  (f) => f.id !== "refund-placement" || siteFlags.showRefundPlacementFaq
);

export const FAQ = () => {
  return (    <section id="faq" data-testid="faq-section" className="bg-[#F0EFEB] py-24 sm:py-32 border-y border-[#1C1C1A]/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-12 gap-y-12 gap-x-8">
          <div className="col-span-12 md:col-span-5">
            <p className="label-eyebrow text-[#143628] mb-5">Frequently asked</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              Questions, <em className="italic text-[#143628]">answered.</em>
            </h2>
            <p className="text-[#4A4A48] mt-6 leading-relaxed">
              Still curious? Drop us a message - a placement specialist will get back within one business day.
            </p>
          </div>

          <div className="col-span-12 md:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-[#1C1C1A]/15"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-serif-display text-xl sm:text-2xl text-[#1C1C1A] hover:text-[#143628] hover:no-underline py-5"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-[#4A4A48] text-base leading-relaxed pb-6 pr-6"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
